<template>
  <div class="recommend-work-item-component"
       @click="handleWorkDetail(item.work.id)"
  >
    <div class="work-container">
      <div class="work-title ym-two-line-ellipsis">{{ item.work.title }}</div>
      <div class="user-container">
        <ym-avatar class="user-avatar"
                   :avatar="item.user.avatar"
                   size="small"
        />
        <div class="user-info">
          <div class="name">{{ item.user.name }}</div>
          <div class="detail-info">{{ item.user.age | formatUserAgeAndArea(item.user.area) }}</div>
        </div>
      </div>
    </div>
    <div class="cover-container">
      <ym-img class="img"
              :src="item.work.cover"
              :alt="item.work.title"
              lazy
      />
    </div>
  </div>
</template>

<script>
  import Avatar from '@/components/Avatar';

  export default {
    name: 'RecommendWorkItemComponent',
    components: {
      'ym-avatar': Avatar,
    },
    props: {
      item: {
        type: Object,
        required: true,
        default() {
          return {};
        },
      },
    },
    methods: {
      handleWorkDetail(id) {
        const route = { name: 'WorkDetail', params: { id } };
        this.$router.push(route);
      },
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .recommend-work-item-component {
    margin: 0 @size-base;
    padding: @size-base 0;
    display: flex;
    justify-content: space-between;
    border-bottom: @border-base;
  }

  .work-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .work-title {
    font-size: @font-size-base;
    font-weight: @font-weight-primary;
    color: @color-text-base;
  }

  .user-container {
    display: flex;
    .user-avatar {
      margin-right: @size-small;
    }
    .name {
      font-size: @font-size-small;
      color: @color-text-base;
    }
    .detail-info {
      font-size: @font-size-small;
      color: @color-text-lighter;
    }
  }

  .user-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .cover-container {
    flex-shrink: 0;
    width: 200px;
    height: 160px;
    background-color: @background-color-base;
    border-radius: @border-radius-base;
    .img {
      display: block;
      width: 100%;
      height: 100%;
      border-radius: @border-radius-base;
    }
  }

</style>
